<template>
  <div class="reconciliation-tab task-details-tabbed__scroll-body" data-testid="reconciliation-tab">
    <div class="reconciliation-tab__panel" data-testid="reconciliation-tab__panel">
      <ReconciliationPanelHeader :task="task" />
      <div class="reconciliation-tab__body" data-testid="reconciliation-tab__body">
        <Reconciliation :task="task" redesign />
      </div>
    </div>
  </div>
</template>

<script>
import Reconciliation from './Reconciliation.vue';
import ReconciliationPanelHeader from './ReconciliationPanelHeader.vue';

export default {
  name: 'ReconciliationTab',

  components: {
    Reconciliation,
    ReconciliationPanelHeader,
  },

  props: {
    task: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/reconciliation-tab';
</style>
